export const AllRoutes = {
    LOGIN:'/',
    USERTYPE:'/usertype',
}